import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import { TiInfoOutline } from "react-icons/ti";
import NoRecord from "app/Components/CommanComponents/NoRecord";

class StackBarChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { categoryData, tooltip, xAxisName, yAxisName, seriesData, series } = this.props;

    const echartBasicBarOption = {
      tooltip: tooltip
        ? tooltip
        : {
          formatter: (params) => {
            return (
              `${params?.data?.name1}<br/>${params?.marker}<br/>${params?.data?.mineFullName}: ${params?.data?.value}<br/>`

            );
          },
        },

      legend: {
        type: "scroll",
        // left: 90,
        // right: 40,
        bottom: 0,
        padding: [
          50, // up
          20, // right
          0, // down
          0, // left
        ],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "8%",
        containLabel: true,
      },
      xAxis: [
        {
          name: xAxisName ? xAxisName : "",
          nameLocation: "middle",
          nameTextStyle: {
            fontWeight: "bold",
            padding: [15, 0, 0, 0],
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            // rotate: 30,
          },
          type: "category",
          data: categoryData ? categoryData : [],
        },
      ],
      yAxis: [
        {
          name: yAxisName ? yAxisName : "",
          nameLocation: "end",
          type: "value",
          min: 0, // minimum value to start
          minInterval: 1, // for integer axis value
          nameTextStyle: {
            fontWeight: "bold",
          },
        },
      ],
      series: seriesData ? seriesData : [],
    };

    return (
      <React.Fragment>
        {(Array.isArray(seriesData) && seriesData.length > 0) || (Array.isArray(series) && series.length > 0) ? (
          <ReactEcharts style={{ height: "250px", margin: "0 auto" }} option={echartBasicBarOption} />
        ) : (
          <NoRecord></NoRecord>
        )}
      </React.Fragment>
    );
  }
}

export default StackBarChart;
